export const RO_RED_NUMBERS = [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36];
export const RO_BLACK_NUMBERS = [2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24, 26, 28, 29, 31, 33, 35];

export const RO_MAPPINGS = {
    '1_12': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    '13_24': [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
    '25_36': [25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36],
    'LOW': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
    'HIGH': [19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36],
    'EVEN': [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36],
    'ODD': [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29, 31, 33, 35],
    'RED': RO_RED_NUMBERS,
    'BLACK': RO_BLACK_NUMBERS,
    'COL_1': [1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34],
    'COL_2': [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35],
    'COL_3': [3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36]
};

export const PHASE_COLORS = {
    bidding: "var(--vz-success)",
    autosubmit: "var(--vz-warning)",
    hold: "var(--vz-danger)",
    default: "var(--vz-primary)"
};

export const MULTIPLIER_OPTIONS = [5, 10, 20, 50, 100];

export const GAME_TYPES = {
    RO: "ro",
    SO: "so",
    LT: "lt",
    LT1: "lt1",
    LT3: "lt3",
    ALL: "all"
};

export const GAME_MODES = {
    MORE_EASY: "more_easy",
    EASY: "easy",
    MEDIUM: "medium",
    HARD: "hard"
};

export const CACHE_KEYS = {
    RO: "american-roulette",
    LT: "lucky-target",
    LT1: "lucky-target-1",
    LT3: "lucky-target-3",
    lt3: "lucky-target-3",
    SO: "sorat"
};

export const RETRY_INTERVAL = 5000;
export const DEFAULT_PAGE_SIZE = 10;

export const SITE_TITLE = process.env.REACT_APP_SITE_TITLE || "Admin Panel";

export const SOCKET_EVENTS = {
    RO: {
        TIMER: "ro-timerUpdate",
        PHASE: "ro-phaseChange",
        NEW_ROUND: "ro-newRound",
        PLACE_BID: "ro-placeBid",
        HISTORY: "ro-lastTenWinners",
        HISTORY_FALLBACK: "ro-lastTenWinner",
        MANUAL_CONFIRMED: "ro-manualWinnerConfirmed",
        MANUAL_WINDOW: "ro-manualWinnerWindow",
        PLAY_SPIN: "ro-playSpin"
    },
    SO: {
        TIMER: "so-timerUpdate",
        HISTORY: "so-lastTenWinners",
        GET_USER_LAST_BID: "so-getUserLastBid",
        USER_LAST_BID_RESPONSE: "so-userLastBidResponse",
        BID_UPDATE: "so-bidUpdate",
        MANUAL_WINDOW: "so-manualWinnerWindow",
        NEW_ROUND: "so-newRound",
        ROUND_COMPLETED: "so-roundCompleted",
        PLACE_BID: "so-placeBid",
        HISTORY_FALLBACK: "so-lastTenWinner",
        PLAY_SPIN: "so-playSpin"
    },
    LT1: {
        TIMER: "lt1-timerUpdate",
        BID_UPDATE: "lt1-bidUpdate",
        MANUAL_WINDOW: "lt1-manualWinnerWindow",
        NEW_ROUND: "lt1-newRound",
        ROUND_COMPLETED: "lt1-roundCompleted",
        PLACE_BID: "lt1-placeBid",
        HISTORY: "lt1-lastTenWinners",
        HISTORY_FALLBACK: "lt1-lastTenWinner",
        PLAY_SPIN: "lt1-playSpin"
    },
    LT3: {
        TIMER: "lt3-timerUpdate",
        BID_UPDATE: "lt3-bidUpdate",
        MANUAL_WINDOW: "lt3-manualWinnerWindow",
        NEW_ROUND: "lt3-newRound",
        ROUND_COMPLETED: "lt3-roundCompleted",
        PLACE_BID: "lt3-placeBid",
        HISTORY: "lt3-lastTenWinners",
        HISTORY_FALLBACK: "lt3-lastTenWinner",
        PLAY_SPIN: "lt3-playSpin"
    },
    lt3: {
        TIMER: "lt3-timerUpdate",
        BID_UPDATE: "lt3-bidUpdate",
        MANUAL_WINDOW: "lt3-manualWinnerWindow",
        NEW_ROUND: "lt3-newRound",
        ROUND_COMPLETED: "lt3-roundCompleted",
        PLACE_BID: "lt3-placeBid",
        HISTORY: "lt3-lastTenWinners",
        HISTORY_FALLBACK: "lt3-lastTenWinner",
        PLAY_SPIN: "lt3-playSpin"
    },
    GLOBAL: {
        HISTORY: "lastTenWinners",
        HISTORY_SINGULAR: "lastTenWinner"
    }
};
